export const OBJECT_TYPE_VIDEO = 'OBJECT_TYPE_VIDEO'